<div mat-dialog-title class="dialog-header fax-detail-header">
   <h3 class="dialog-title">Fax Details</h3>
   <h4 class="fax-date">{{ faxLogs.createDate | date : 'MMM d, y, hh:mm:ss aa' }}</h4>
</div>
<mat-dialog-content class="dialog-body mat-dialog-content-no-heading">
   <section class="fax-summary-card">
      <div class="summary-grid">
         <div class="summary-item">
            <span class="summary-label"><mat-icon class="summary-icon">call_made</mat-icon>From</span>
            <span class="summary-value">{{ faxLogs.faxSource | formatPhoneNumbers | addSpaces }}</span>
         </div>
         <div class="summary-item">
            <span class="summary-label"><mat-icon class="summary-icon">call_received</mat-icon>To</span>
            <span class="summary-value">{{ faxLogs.faxDestination | formatPhoneNumbers }}</span>
         </div>
         <div class="summary-item">
            <span class="summary-label">Status</span>
            <span class="summary-value">{{ faxLogs.faxStatus | addSpaces }}</span>
         </div>
         <div class="summary-item">
            <span class="summary-label">{{ faxLogs.faxType === faxTypes.Received ? 'Received' : 'Sent' }}</span>
            <span class="summary-value">{{ (faxLogs.processedTime | date : 'MMM d, y, hh:mm:ss aa') ?? 'N/A' }}</span>
         </div>
         <div class="summary-item">
            <span class="summary-label">Fax Id</span>
            <span class="summary-value">{{ faxLogs.faxId }}</span>
         </div>
         @if (faxLogs.exceptionMessage) {
         <div class="summary-item summary-item-full">
            <span class="summary-label"><mat-icon class="summary-icon">error_outline</mat-icon>Error</span>
            <span class="summary-value">{{ faxLogs.exceptionMessage }}</span>
         </div>
         }
      </div>
   </section>

   @if (isSystemUser) {
   <mat-expansion-panel
      class="technical-details-panel"
      [expanded]="(advancedSectionExpanded$ | async) ?? false"
      (opened)="onAdvancedSectionToggled(true)"
      (closed)="onAdvancedSectionToggled(false)"
   >
      <mat-expansion-panel-header>
         <mat-panel-title><mat-icon class="section-icon">settings</mat-icon>Advanced Details</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="tech-grid">
         <div class="tech-item">
            <span class="tech-label">Server</span>
            <span class="tech-value">{{ serverDetails || 'N/A' }}</span>
         </div>
         <div class="tech-item">
            <span class="tech-label">SIP Id</span>
            <span class="tech-value">
               @if (faxLogs.sipCallId) {
               <mat-icon
                  class="sip-id-copy-icon"
                  (click)="copySipIdToClipboard(faxLogs.sipCallId); $event.preventDefault(); $event.stopPropagation()"
                  >content_copy</mat-icon
               >
               {{ faxLogs.sipCallId }}
               } @else { N/A }
            </span>
         </div>
         <div class="tech-item">
            <span class="tech-label">Provider</span>
            <span class="tech-value">{{ providerName || 'N/A' }}</span>
         </div>
         <div class="tech-item">
            <span class="tech-label">Remote IP</span>
            <span class="tech-value">{{ faxLogs.associatedIp || 'N/A' }}</span>
         </div>
         @if (faxLogs.sipCallId) {
         <div class="tech-item">
            <span class="tech-label">Check fax logs on</span>
            <span class="tech-value tech-value-actions">
               <button
                  type="button"
                  mat-button
                  color="primary"
                  class="logo-button"
                  (click)="openLink(graylogSipCallIdLogsLink)"
               >
                  <ndt-graylog-logo class="button-logo-standalone"></ndt-graylog-logo>
                  Graylog
               </button>
               <button
                  type="button"
                  mat-button
                  color="primary"
                  class="logo-button"
                  (click)="openLink(homerSipCallIdLogsLink)"
               >
                  <ndt-homer-logo class="button-logo-standalone"></ndt-homer-logo>
                  Homer
               </button>
            </span>
         </div>
         }
      </div>
   </mat-expansion-panel>
   } @if ((faxLogs.attachments?.items?.length ?? 0) > 0 && faxLogs.faxStatus != faxStatuses.Successful &&
   faxLogs.faxStatus != faxStatuses.Errored) {
   <section class="attachments-section">
      <h5 class="section-heading"><mat-icon class="section-icon">attach_file</mat-icon>Attachments</h5>
      <lcs-responsive-table [columns]="columns">
         <table lcs-table [dataSource]="faxLogs.attachments?.items ?? []">
            <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
            <tr lcs-row *lcsResponsiveRowDef></tr>
            <ng-container lcsColumnDef="DisplayName" [width]="1">
               <th lcs-header-cell *lcsHeaderCellDef>File Name</th>
               <td lcs-cell *lcsCellDef="let fax"> {{ fax.file?.displayName }}</td>
            </ng-container>
            <ng-container lcsColumnDef="Type" [width]="0.5">
               <th lcs-header-cell *lcsHeaderCellDef>Type</th>
               <td lcs-cell *lcsCellDef="let fax"> {{ fax.file?.type }}</td>
            </ng-container>
            <ng-container lcsColumnDef="Status" [width]="1">
               <th lcs-header-cell *lcsHeaderCellDef>Status</th>
               <td lcs-cell *lcsCellDef="let fax"> {{ fax.faxStatusId }}</td>
            </ng-container>
            <ng-container lcsColumnDef="Download" [width]="1">
               <th lcs-header-cell *lcsHeaderCellDef></th>
               <td lcs-cell *lcsCellDef="let fax">
                  @if (fax.file) {
                  <button
                     mat-menu-item
                     type="button"
                     id="fax-details"
                     (click)="downloadFile(fax.file?.fileToken, fax.file?.displayName)"
                     ><b><u>Download</u></b>
                  </button>
                  }</td
               >
            </ng-container>
         </table>
      </lcs-responsive-table>
   </section>
   }
</mat-dialog-content>
<mat-dialog-actions>
   <button type="button" mat-raised-button color="primary" (click)="onCloseClick()">Close</button>
</mat-dialog-actions>
